export default __webpack_public_path__ + "static/media/img11.da1eb4a7.PNG";